import { render, staticRenderFns } from "./ExamsLibrary.vue?vue&type=template&id=23e0268c&"
import script from "./ExamsLibrary.vue?vue&type=script&lang=js&"
export * from "./ExamsLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports